module.exports = __webpack_public_path__ + "img/i-trello-admin.03a90086.svg";